import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import PhonePerformanceMetricsColumns from '../common-columns/phone-performance-metrics-columns';
import SOVColumns from '../common-columns/sov-columns';
import SOVLostColumns from '../common-columns/sov-lost-columns';
import QualityScoreColumns from '../common-columns/quality-score-columns';
import getLevel from '../util/get-level';

export function getColumnsMetadata() {
  return _.defaults(
    {
      Keyword: 'Text',
      Campaign: 'Campaign/Name',
      AdGroup: 'AdGroup/Name',
      BidStrategyName: 'Campaign/BidStrategyName',
      BidStrategyType: 'BiddingScheme',
      Bid: 'Bid/Amount',
      Delivery: 'DeliveryStatus',
      LandingPage: ['DestinationUrl', 'FinalUrls', 'MobileFinalUrls'],
      CustomParameters: 'UrlCustomParameters',
      TrackingTemplate: 'TrackingUrlTemplate',
      FirstPageBidEstimation: 'BidEstimate/FirstPageBidEstimation',
      MainlineBidEstimation: 'BidEstimate/MainlineBidEstimation',
      BestPositionBidEstimation: 'BidEstimate/BestPositionBidEstimation',
      KeywordId: 'Id',
    },
    PerformanceMetricsColumns,
    PhonePerformanceMetricsColumns,
    SOVColumns,
    SOVLostColumns,
    QualityScoreColumns
  );
}

export function getRoute({
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  switch (level) {
    case 'AdGroup':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/keyword/positive';
    case 'Campaign':
      return 'customer/:customer_id/account/:account_id/campaign/:campaign_id/keyword/positive';
    case 'Account':
    default:
      return 'customer/:customer_id/account/:account_id/keyword/positive';
  }
}
